const i18n = {
    en: {
        description: {
            start: "You received an offer of",
            middle: "for",
        },
        title: "Offer Received",
    },
    es: {
        description: {
            start: "Recibiste una oferta de",
            middle: "para",
        },
        title: "Oferta recibida",
    },
    zh: {
        description: {
            start: "您的出价",
            middle: "已被接受",
        },
        title: "收到报价",
    },
};
export { i18n };
//# sourceMappingURL=BidReceivedNotification.i18n.js.map